import React from 'react';
import { Field, FormikErrors } from 'formik';

interface PersonType {
  _id: string;
  name: string;
  minAge: number;
  maxAge: number;
}

interface PersonTypePrice {
  personTypeId: string;
  price: number;
  priceHT: number;
}

interface PersonTypePriceRowProps {
  index: number;
  typedErrors: any;
  typedTouched: any;
  personTypes: PersonType[];
  setFieldValue: any;
  intl: any;
  remove: (index: number) => void;
  values: any;
  calculatePriceHT: (priceTTC: number) => number;
  allSelected: boolean;
}

export const PersonTypePriceRow: React.FC<PersonTypePriceRowProps> = ({
  index,
  typedErrors,
  typedTouched,
  personTypes,
  setFieldValue,
  intl,
  remove,
  values,
  calculatePriceHT,
  allSelected
}) => {
  const personTypeError = typedErrors.personTypePrices &&
    Array.isArray(typedErrors.personTypePrices) ?
    typedErrors.personTypePrices[index] as FormikErrors<PersonTypePrice> :
    undefined;

  const personTypeTouched = typedTouched.personTypePrices &&
    Array.isArray(typedTouched.personTypePrices) ?
    typedTouched.personTypePrices[index] as { [K in keyof PersonTypePrice]?: boolean } :
    undefined;

  const rowValue = values.personTypePrices[index];
  const currentPersonTypes = values.personTypePrices
    .map((p: any, i: number) => i !== index ? p.personTypeId : null)
    .filter(Boolean);
  const availablePersonTypes = personTypes.filter((pt: any) => !currentPersonTypes.includes(pt._id));

  return (
    <div className='row mb-3 align-items-end'>
      <div className='col-md-6'>
        <label className='form-label required'>
          {intl.formatMessage({ id: 'TOUR.PRICING.PERSON_TYPE' })}
        </label>
        <Field
          as='select'
          name={`personTypePrices.${index}.personTypeId`}
          className={`form-select form-select-lg ${
            personTypeError?.personTypeId && personTypeTouched?.personTypeId ? 'is-invalid' : ''
          }`}
        >
          <option value=''>
            {intl.formatMessage({ id: 'COMMON.SELECT' })}
          </option>
          {[
            ...(rowValue.personTypeId ? [personTypes.find((pt: any) => pt._id === rowValue.personTypeId)] : []),
            ...availablePersonTypes.filter((pt: any) => pt._id !== rowValue.personTypeId)
          ].filter((pt: any) => pt !== undefined).map((pt: any) => (
            <option key={pt._id} value={pt._id}>
              {pt.name} ({pt.minAge}-{pt.maxAge === 999 ? '+' : pt.maxAge} {intl.formatMessage({ id: 'COMMON.YEARS' })})
            </option>
          ))}
        </Field>
        {personTypeError?.personTypeId && personTypeTouched?.personTypeId && (
          <div className='invalid-feedback'>
            {personTypeError.personTypeId}
          </div>
        )}
      </div>
      <div className='col-md-5 position-relative'>
        <label className='form-label required'>
          {intl.formatMessage({ id: 'COLUMNS.PRICE' })}
        </label>
        <Field
          name={`personTypePrices.${index}.price`}
          type='number'
          min='0.01'
          step='0.01'
          className={`form-control form-control-lg ${
            personTypeError?.price && personTypeTouched?.price ? 'is-invalid' : ''
          }`}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const price = parseFloat(e.target.value)
            setFieldValue(`personTypePrices.${index}.price`, price)
            setFieldValue(
              `personTypePrices.${index}.priceHT`,
              calculatePriceHT(price)
            )
          }}
        />
        {personTypeError?.price && personTypeTouched?.price && (
          <div className='invalid-feedback position-absolute' style={{ left: 0, bottom: '-1.5rem' }}>
            {personTypeError.price}
          </div>
        )}
      </div>
      <div className='col-md-1'>
        <button
          type='button'
          className='btn btn-sm btn-icon btn-light-danger mt-8'
          onClick={() => remove(index)}
          disabled={values.personTypePrices.length <= 1}
        >
          <i className='fas fa-trash-alt'></i>
        </button>
      </div>
    </div>
  );
}; 